import React from "react";
import Img from 'gatsby-image'
import Helmet from "react-helmet";

import Header from "../components/Header";
import ServicePlanSummary from "../components/ServicePlanSummary";

class Homepage extends React.Component {

    componentDidMount () {
      this.props.history.listen(({ hash }) => {
          if (hash) {
            const section = document.getElementById(hash.replace('#', ''));
              if(!!section) {
                 section.scrollIntoView();
                 return;
              }
          }
          window.scrollTo(0, 0);
      });
    }

    render() {
        const siteTitle = this.props.data.site.siteMetadata.title;
        // const servicePlans = this.props.data.servicePlans.edges
        //     .map(i => {
        //         return i.node;
        //     })
        //     .sort((a, b) => {
        //         return a.sortOrder - b.sortOrder;
        //     });

        const imageSizes = {
            bronze: this.props.data.bronzeImage,
            gold: this.props.data.goldImage,
            platinum: this.props.data.platinumImage,
        }

        return (
            <div>
                <Helmet title={siteTitle} />

                <section id="contact" className="cta-top">
                    <div className="grid-wrapper">
                        <div className="col-4 prompt-text">
                            <h2>Need service now?</h2>
                            <p>
                                Submit a service request, or request a callback.
                            </p>
                        </div>
                        <div className="col-8 action-buttons">
                            <p className="phone-number">
                                <a href="tel:+15128042500">
                                    512-804-2500
                                </a>
                            </p>
                            <ul className="actions uniform">
                                <li>
                                    <a href="/service-request" className="button special">
                                        Service Request
                                    </a>
                                </li>
                                {/* <li>
                                    <a href="/request-callback" className="button special">
                                        Request Callback
                                    </a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </section>

                <Header headerImage={this.props.data.headerImage} />

                <section id="replace" className="main style1">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            <header className="major">
                                <h2>
                                    Time to replace?
                                </h2>
                                <h3>
                                    Our HVAC experts can find the solution for you
                                </h3>
                            </header>
                            <p>
                                Our complete line of air conditioners are priced to help add comfort
                                to your budget. And that’s only the beginning. We want you to smile
                                every time you open your utility bill, so we design energy efficient
                                technology into our systems.  With lifetime compressor limited
                                warranties and 10 year parts limited warranties, we will make sure
                                your new system will run perfectly for years to come.
                            </p>
                        </div>
                        <div className="col-6">
                            <span className="image fit">
                                <Img
                                    className=""
                                    sizes={this.props.data.replaceImage.sizes}
                                    alt="EMS Home Services, HVAC Services, Austin TX"
                                />
                            </span>
                        </div>
                    </div>
                </section>

                <section id="repair" className="main style2">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            <span className="image fit">
                                <Img
                                    className=""
                                    sizes={this.props.data.repairImage.sizes}
                                    alt="EMS Home Services, HVAC Services, Austin TX"
                                />
                            </span>
                        </div>
                        <div className="col-6">
                            <header className="major">
                                <h2>
                                    Sometimes things break...
                                </h2>
                                <h3>
                                    Our team of experienced technicians are the best in the business
                                </h3>
                            </header>
                            <p>With decades of experience our service technicians can get you out of the tightest of jams.  Our experienced staff will make real world suggestions to you regardinging the maintenance or replacment of your equipment.  Their job is to make sure your system runs at peak performance at all times without break downs.</p>
                        </div>
                    </div>
                </section>

                {/* <section id="maintain" className="main style3 special">
                    <div className="grid-wrapper">
                        <div className="col-12">
                            <header className="major">
                                <h2>
                                    EMS Home Services Maintenance Plans
                                </h2>
                            </header>

                            <p>
                                Protect your HVAC investment with a maintenance plan.
                            </p>

                            <ul className="actions uniform">
                                <li><a href="/service-plans" className="button special">View Plans</a></li>
                            </ul>
                        </div>

                        {servicePlans.map(plan => {
                            return <ServicePlanSummary
                                plan={plan}
                                imageSizes={imageSizes}
                                showFeatures={true}
                            />
                        })}
                    </div>
                </section> */}

            </div>
        );
    }
}

Homepage.propTypes = {
    route: React.PropTypes.object
};

export default Homepage;

export const pageQuery = graphql`
    query IndexQuery {
        repairImage: imageSharp(id: { regex: "/repair.jpg/" }) {
            sizes(maxWidth: 600 ) {
                ...GatsbyImageSharpSizes
            }
        }
        replaceImage: imageSharp(id: { regex: "/replace.jpg/" }) {
            sizes(maxWidth: 600 ) {
                ...GatsbyImageSharpSizes
            }
        }
        bronzeImage: imageSharp(id: { regex: "/bronze.png/" }) {
            sizes(maxWidth: 500 ) {
                ...GatsbyImageSharpSizes
            }
        }
        goldImage: imageSharp(id: { regex: "/gold.png/" }) {
            sizes(maxWidth: 500 ) {
                ...GatsbyImageSharpSizes
            }
        }
        platinumImage: imageSharp(id: { regex: "/platinum.png/" }) {
            sizes(maxWidth: 500 ) {
                ...GatsbyImageSharpSizes
            }
        }
        headerImage: imageSharp(id: { regex: "/ems-home-services-logo-lg/" }) {
            sizes(maxWidth: 400 ) {
                ...GatsbyImageSharpSizes
            }
        }
        site {
            siteMetadata {
                title
            }
        },
        servicePlans: allServicePlansJson {
            edges {
                node {
                    name,
                    description,
                    features,
                    costMonth,
                    costYear,
                    imageKey,
                    sortOrder
                }
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/pages/index.js